// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCz3n63o6njKjb2xlDVYpKAJ08lJRRoacE",
  authDomain: "evan-jelle-site.firebaseapp.com",
  projectId: "evan-jelle-site",
  storageBucket: "evan-jelle-site.appspot.com",
  messagingSenderId: "848832215567",
  appId: "1:848832215567:web:deb8a89375ed5b5463a7c1",
  measurementId: "G-TWT3QLBZ2T"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Firestore is the only service we need on the client right now
export const db = getFirestore(app);
